<div class="pt-3 pb-2 mb-3">
	<div class="shadow-lg p-3 mb-5 bg-white rounded table-responsive">
		<table *ngIf="payload" class="table table-hover">
			<thead>
				<tr>
					<th>ID</th>
					<th>Created At</th>
					<th>Kiosk</th>
					<th>Status</th>
					<th>Report File</th>
					<th>Document Number</th>
					<th>Error</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let data of payload">
					<th scope="row">{{data.id}}</th>
					<td>{{data.createdAt | date:'yyyy-MM-dd HH:mm:ss'}}</td>
					<td>{{util.getKioskDetails(data.kiosk)}}</td>
					<td>{{data.status}}</td>
					<td *ngIf="data.reportFileName"><button type="button" class="btn btn-primary" (click)="downloadReport(data)">Download</button></td>
					<td *ngIf="!data.reportFileName"></td>
					<td>{{data.documentNumber}}</td>
					<td>{{data.error}}</td>
					
				</tr>
			</tbody>
		</table>
	</div>
</div>
